import { PricingItem } from "../pricing-item/pricing-item";

export class  CustomGroup {
    constructor(
        public id?: string,
        public title?: string,
        public order?: number,
        public pricingItems?: PricingItem[],
        public isDuplicated?: boolean,
        public totalAppliedPrice?: string
    ) {

    }

    
}
